module.exports = __webpack_public_path__ + "static/media/Firebase.2c54805b.png";